export default function Profile() {
  return (
    <section className="doc" id="profile">
      <div className="sheet">
        <p className="sec-label mono">SEC. 04 — 担当技術者</p>
        <h2>現場と設計を知るエンジニアが、直接担当します</h2>
        <div className="profile-grid">
          <div className="profile-text">
            <p>
              大手製造業で10年以上、設計開発・生産技術の現場で働いてきました。鍛造・切削工程の立上げや製造現場のDX推進に従事する中で、「現場の課題をどう解決するか」を問い続けてきました。
            </p>
            <p>
              その後、製造業向けシステム開発を手がけるSIerにて製造現場DXに携わり、続いてAI開発に特化したスタートアップにて大手メーカーのAI-PoC・開発プロジェクトを複数担当。要件定義から実装・納品まで一貫して対応してきました。
            </p>
            <p>
              技術ありきではなく、課題ありきで。現場の言葉で話し、現場で使われるものを作る——その思いでEngiMindを立ち上げました。
            </p>
          </div>
          <div className="profile-side">
            <div className="title-block">
              <table>
                <caption>EngiMind（エンジマインド）</caption>
                <tbody>
                  <tr><th>専門</th><td>図面・設計計算・業務ロジックの自動化／製造業・建設業向けAI・ITツール開発</td></tr>
                  <tr><th>経歴</th><td>大手製造業（設計開発・生産技術）→ SIer → AIスタートアップ</td></tr>
                  <tr><th>対応</th><td>ヒアリング〜提案〜開発〜導入・運用まで一貫</td></tr>
                  <tr><th>相談</th><td>初回無料・オンライン可</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
